// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__1daQT"};